














import {
  defineComponent, ref, useContext, useFetch
} from '@nuxtjs/composition-api';
import getCustomForm from "~/customQueries/queries/getCustomForm.gql";
import Form from '~/components/Palmers/BaseComponents/Form/Form.vue';

export default defineComponent({
  name: 'ElementAmastyForm',
  components: {
    Form
  },
  props: {
    element: {
      type: Object,
      require: true
    }
  },
  setup(props) {
    const loaded = ref(false);
    const {$vsf} = useContext();
    const amastyForm = ref({});

    useFetch(async () => {
      if (!props?.element?.['form']) return;

      const customFormData = await $vsf.$magento.api.customQuery({
        query: getCustomForm,
        queryVariables: {
          form_id: props.element['form'],
          cacheType: `AMASTY_CUSTOMFORM_${props.element['form']}`
        }
      });

      amastyForm.value = customFormData.data?.['customform'];

      loaded.value = true;
    });

    return {
      loaded,
      amastyForm
    }
  }
});
